<style>
input:checked ~ .radio {
    color:white;
    background-color: #084772;
}
</style>
<template>
    <div class="pt-6">
        <!-- Start Filter section -->
        <div class="relative z-10 px-2 sm:flex items-center justify-center sm:inset-0 w-full lg:mr-20 mr-0 rounded-full">
            <ProFilter
                :user="user"
                :industries="industries"
                :industry="industry"
                :professions="professions"
                :profession="profession"
                :organization="organization"
                :search-options="searchOptions"
                :radius-choices="radiusChoices"
                :initialRadius="radius"
                :withSubmit="withSubmit"
                :initialSort="sortBy"
                :pros="filteredPros"
                v-on:applyFilters="applyFilters"
                v-on:sortPros="sortPros"
            />
        </div>
        <!-- end filter section -->
        <div>
            <v-alert
                type="success" outlined :show="showResults" class="mt-6"
            >{{ resultsMessage }}</v-alert>
        </div>
        <div class=" overflow-y: auto">
            <div v-if="filteredPros.count !== 0"
                class="flex flex-row mx-auto grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 pt-6 gap-8"
            >
                <ConnectedPro
                    class="connected-pro"
                    v-for="(pro, i) in filteredPros"
                    v-on="updatePros"
                    :pro="pro"
                    :key="pro.id"
                    :user="user"
                    :showFeatured="false"
                    v-on:openPingModal="openPingModal"
                    v-on:openShareModal="openShareModal"
                />
            </div>
            <div
                v-if="isLoading"
                style="border-top-color: transparent"
                class="w-8 h-8 border-4 mx-auto my-5 border-blue-400 border-solid rounded-full animate-spin"
            ></div>
        </div>
    </div>
</template>

<script>
import ConnectedPro from '../../Dashboard/partials/ConnectedPro.vue';
import ProFilter from './ProFilter.vue';
export default {
    mounted() {
//        console.log( JSON.stringify( this.pros));
//        console.log( this.pros['data']);
        console.log( "sort order: ");
        console.log( this.sortOrder);
        console.log( "radius: " + this.radius);
    },
    data() {
        return {
            selectedIndustry: this.industry,
            premiumOnly: (this.filters.indexOf('premium') !== -1 ? 'premium' : 'all'),
            selectedProfession: this.profession,
            filteredProfessions: [{name: "All"}, ...this.professions],
            filteredPros: this.pros,
            industriesData: [{name: "All"}, ...this.industries],
            paginationData: null,
            data: null,
            isLoading: false,
            isSearching: false,
            search_location: ( this.postal_code ? {
                'postal_code': this.postal_code
            } : (this.user && this.user.home_location
                && this.user.home_location.lat && this.user.home_location.lng) ? {
                'lat': this.user.home_location.lat,
                'lng': this.user.home_location.lng,
                'postal_code': this.user.home_location.postal_code
            } : ((this.user && this.user.business_location
                && this.user.business_location.lat && this.user.business_location.lng) ? {
                'lat': this.user.business_location.lat,
                'lng': this.user.business_location.lng,
                'postal_code': this.user.business_location.postal_code
            } : null)),
//            radiusChoices: ["5mi", "10mi", "25mi", "50mi", "200mi", "500mi", "1000mi","5000mi"],
            search_text: this.text,
            walkinsWelcome: false,
            selectedRadius: this.radius ? this.radius : "50mi",
            sortBy: this.sortOrder[0],
            showResults: false,
            resultsMessage: "",
        }
    },
    props: ["text",
            "user",
            "pros",
            "industries",
            "industry",
            "professions",
            "profession",
            "organization",
            "filters",
            "updatePros",
            "postal_code",
            "lat",
            "lng",
            "radius",
            "withSubmit",
            "searchOptions",
            "initiallyPremium",
            "radiusChoices",
            "sortOrder",
        ],
    components: {
        ConnectedPro,
        ProFilter,
    },
    methods: {
        relevanceSort( pros){
            const comparator = ( a, b) => {
                if( a.relevance < b.relevance) return 1;
                if( a.relevance > b.relevance) return -1;
                return 0;
            }
            return pros.sort( comparator);
        },
        distanceSort( pros){
            const comparator = ( a, b) => {
                if( a.distance < b.distance) return -1;
                if( a.distance > b.distance) return 1;
                return 0;
            };
            return pros.sort( comparator);
        },
        alphaSort( pros){
            const comparator = ( a, b) => {
                if( a.last_name < b.last_name) return -1;
                if( a.last_name > b.last_name) return 1;
                if( a.first_name < b.first_name) return -1;
                if( a.first_name > b.first_name) return 1;
                return 0;
            };
            return pros.sort( comparator);
        },
        careScoreSort( pros){
            const comparator = ( a, b) => {
                if( a.care_score > b.care_score) return -1;
                if( a.care_score < b.care_score) return 1;
                return 0;
            };
            return pros.sort( comparator);
        },
        narrowProfessions() {
            this.filteredProfessions = [{name: "All"}, ...this.professions.filter( this.matchIndustry)];
        },
        matchIndustry( profession) {
            if( this.selectedIndustry && this.selectedIndustry !== 'all'){
                return this.selectedIndustry === profession.industry_id;
            } else {
                return true; // for no selected industry, back to all
            };
        },
        openPingModal(member) {
            this.$emit("openPingModal", member);
        },
        openShareModal( member){
            this.$emit( "openShareModal", member);
        },
        async applyFilters( filters){
            let searchURL = '/search';
            console.log( "applyFilters");
            console.log( filters.postal_code);
            const params = new URLSearchParams();
            if( filters.search_text) params.append( 'search_text', filters.search_text);
            if( filters.selectedRadius) params.append( 'radius', filters.selectedRadius);
            if( filters.sortBy === 'alpha' && filters.postal_code)
                params.append( 'sort_order', '["alpha", "distance", "relevance"]')
            else if( filters.sortBy === 'distance')
                params.append( 'sort_order', '["distance", "relevance"]');
            else if( filters.sortBy === 'relevance')
                params.append( 'sort_order', '["relevance", "distance"]');
            else
//                params.append( 'sort_order', '["care_score", "distance", "relevance"]');
                params.append( 'sort_order', '["alpha", "relevance"]');
            if( filters.postal_code) {
                params.append( 'postal_code', filters.postal_code);
                if( this.search_location && this.search_location.postal_code
                    && (this.search_location.postal_code === filters.postal_code)){
                    if( this.search_location.lat && this.search_location.lng){
                        params.append('lat', this.search_location.lat);
                        params.append( 'lng', this.search_location.lng);
                    }
                }
            } else if( this.search_location && this.search_location.lat && this.search_location.lng) {
//                console.log( 'lat & lng');
                params.append('lat', this.search_location.lat);
                params.append( 'lng', this.search_location.lng);
            } else if( this.search_location && this.search_location.postal_code) {
//                console.log( 'postal_code');
                params.append( 'postal_code', this.search_location.postal_code);
            } else if ("geolocation" in navigator) {
//                console.log( 'from browser');
                await navigator.geolocation.getCurrentPosition(position => {
                    const { latitude, longitude } = position.coords;
                    this.search_location = { 'lat' : latitude, 'lng' : longitude};
                    params.append(  'lat', this.search_location.lat);
                    params.append( 'lng', this.search_location.lng);
                    },
                    position => {});
            }
            if( filters.selectedIndustry && filters.selectedIndustry !== "0") {
                console.log( 'industry ' + filters.selectedIndustry);
                params.append('industry_id', filters.selectedIndustry);
            }
            if( filters.selectedProfession && filters.selectedProfession !== "0") {
                console.log( 'profession_id ' + this.selectedProfession);
                params.append('profession_id', this.selectedProfession);
            }
            if( this.organization) {
                params.append( 'organization_id', this.organization.id);
                searchURL = '/organizations/' + this.organization.id + '/memberFeed';
            }

            console.log( 'walkins welcome: ' + filters.walkinsWelcome)
            if( filters.walkinsWelcome) params.append( 'walkins_welcome', true);

            //            if( this.premium) filters.push( 'premium');

//            console.log( params);
            axios.post( searchURL, null,{ params })
                  .then( (response) => {
                      this.filteredPros = response.data; // get from reloaded feed
                      if( (typeof this.filteredPros.length === 'undefined') || (this.filteredPros.length === 0)){
                          this.resultsMessage = 'No results returned';
                      } else {
                          this.resultsMessage = this.filteredPros.length + ' results returned';
                      }
                      this.showResults = true;
                      console.log( this.filteredPros);
                      this.$emit( 'updatePros');
                    })
                  .catch(error =>{
                       console.log( error.response.status);
                       console.log( error.response.data.message);
                       this.resultsMessage = '';
                       this.showResults = false;
                       if( error.response.status == 419) {
                           alert('session expired, please refresh page and try again');
                       } else {
                           alert(error.response.data.message);
                       }
                  });
        },
        sortPros( sortBy) {
            console.log( 'sortPros');
            console.log( sortBy );
            console.log( this.filteredPros);
            switch( sortBy){
                case 'relevance':
                    if( "relevance" in this.filteredPros[0])
                        this.filteredPros = this.relevanceSort( this.filteredPros);
                    break;
                case "distance":
                    if( "distance" in this.filteredPros[0])
                        this.filteredPros = this.distanceSort( this.filteredPros);
                    break;
                case "alpha": this.filteredPros = this.alphaSort( this.filteredPros);
                    break;
                case "carescore": this.filteredPros = this.careScoreSort( this.filteredPros);
                    break;
            }
//            console.log( this.filteredPros);
        },
        showOrHidePros() {
//            console.log( this.premiumOnly);
        },
    },
};
</script>
